import { render, staticRenderFns } from "./inputPage.vue?vue&type=template&id=161199aa&"
import script from "./inputPage.vue?vue&type=script&lang=ts&"
export * from "./inputPage.vue?vue&type=script&lang=ts&"
import style0 from "./inputPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports